<template>
  <v-card flat>
    <v-card-text class="pa-0">
      <div class="leave-requests-container py-3">
        <v-skeleton-loader
          v-if="loadingLeaveReClock"
          type="card, card"
          class="mb-4 mx-4"
        ></v-skeleton-loader>

        <div
          v-else-if="
            !leaveReClockApplications || leaveReClockApplications.length === 0
          "
          class="text-center py-8"
        >
          <v-icon size="64" color="grey lighten-1">mdi-clock-outline</v-icon>
          <div class="text-h6 text-h4 mt-2">沒有請假期間打卡紀錄</div>
          <div class="text-body-2 text-h4">目前沒有符合條件的紀錄</div>
        </div>

        <template v-else>
          <v-card
            v-for="application in leaveReClockApplications"
            :key="application.id"
            class="mb-4 mx-4"
            outlined
          >
            <v-card-text class="pa-0">
              <v-row class="px-4 pt-4 pb-0">
                <v-col cols="12" md="4">
                  <span class="font-weight-medium text-h5">
                    {{
                      application.applicant && application.applicant.name
                        ? application.applicant.name
                        : `申請單 #${application.id}`
                    }}
                  </span>
                  <v-chip
                    x-medium
                    label
                    :color="REVIEW_STATUS_COLOR[application.review_status]"
                    text-color="white"
                    class="ml-2 px-2"
                  >
                    {{ REVIEW_STATUS_TEXT[application.review_status] }}
                  </v-chip>
                  <div
                    class="text-subtitle-2 text-h4 font-weight-bold blue--text"
                  >
                    <span>{{ getLeaveTypeText(application) }}</span>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <span class="text-h5 mb-0">
                    申請日期:
                    <formatted-date :date="application.create_time" />
                  </span>
                </v-col>
                <v-col cols="12" md="4">
                  <span class="text-h5 grey--text text--darken-1 mb-0">
                    期間:
                    <formatted-date :date="application.start_time" />
                    ~
                    <formatted-date :date="application.end_time" />
                  </span>
                </v-col>
              </v-row>

              <v-row class="px-4 py-0 my-0">
                <v-col cols="12" md="4">
                  <div class="text-h6">請假分鐘:</div>
                  <div>{{ formatLeaveMinutes(application.leave_minutes) }}</div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="text-h6">事由:</div>
                  <div>{{ application.reason || "-" }}</div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="text-h6">員工:</div>
                  <div>
                    {{
                      application.applicant ? application.applicant.name : "-"
                    }}
                  </div>
                </v-col>
              </v-row>

              <v-divider class="mx-4 my-4"></v-divider>

              <div class="px-4 pb-2 font-weight-bold text-h6">打卡紀錄</div>
              <div class="px-4 pb-4">
                <v-card
                  v-for="clockRecord in application.clockRecords"
                  :key="clockRecord.id"
                  outlined
                  class="mb-3"
                >
                  <v-card-text>
                    <div
                      class="
                        d-flex
                        align-center
                        justify-space-between
                        flex-wrap
                      "
                    >
                      <div class="text-subtitle-1 font-weight-medium">
                        日期：<formatted-date :date="clockRecord.clock_date" />
                      </div>
                      <div
                        v-if="
                          clockRecord.extra &&
                          (clockRecord.extra.re_clock_in ||
                            clockRecord.extra.re_clock_out)
                        "
                      >
                        <v-chip small color="green" text-color="white"
                          >請假期間打卡</v-chip
                        >
                      </div>
                    </div>

                    <v-row class="mt-2">
                      <v-col
                        cols="12"
                        md="4"
                        v-if="clockRecord.clock_in_actual"
                      >
                        <div class="text-h6">實際上班打卡:</div>
                        <div>
                          {{ formatDateTime(clockRecord.clock_in_actual) }}
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                        v-if="clockRecord.clock_out_actual"
                      >
                        <div class="text-h6">實際下班打卡:</div>
                        <div>
                          {{ formatDateTime(clockRecord.clock_out_actual) }}
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                        v-if="clockRecord.extra && clockRecord.extra.status"
                      >
                        <div class="text-h6">狀態:</div>
                        <div>{{ clockRecord.extra.status }}</div>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                        v-if="
                          clockRecord.extra && clockRecord.extra.re_clock_in
                        "
                      >
                        <div class="text-h6">請假期間上班:</div>
                        <div>
                          {{ formatDateTime(clockRecord.extra.re_clock_in) }}
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                        v-if="
                          clockRecord.extra && clockRecord.extra.re_clock_out
                        "
                      >
                        <div class="text-h6">請假期間下班:</div>
                        <div>
                          {{ formatDateTime(clockRecord.extra.re_clock_out) }}
                        </div>
                      </v-col>
                      <!-- <v-col cols="12" md="4" v-if="clockRecord.late !== null && clockRecord.late !== undefined">
                        <div class="text-h6">遲到分鐘:</div>
                        <div>{{ clockRecord.late }}</div>
                      </v-col>
                      <v-col cols="12" md="4" v-if="clockRecord.early !== null && clockRecord.early !== undefined">
                        <div class="text-h6">早退分鐘:</div>
                        <div>{{ clockRecord.early }}</div>
                      </v-col> -->
                    </v-row>

                    <v-divider class="my-4"></v-divider>

                    <div class="d-flex align-center justify-end flex-wrap">
                      <v-btn
                        class="
                          font-weight-bold
                          text-capitalize
                          bg-gradient-default
                          mr-2
                        "
                        color="secondary"
                        depressed
                        :disabled="
                          !canReviewClockRecord(clockRecord) ||
                          isActionLoading(clockRecord.id, 'ignore') ||
                          isActionLoading(clockRecord.id, 'approve')
                        "
                        :loading="isActionLoading(clockRecord.id, 'ignore')"
                        @click="openIgnoreDialog(clockRecord)"
                      >
                        <v-icon left size="18">mdi-close-circle-outline</v-icon>
                        忽略打卡紀錄
                      </v-btn>

                      <v-btn
                        class="
                          font-weight-bold
                          text-capitalize
                          bg-gradient-primary
                        "
                        color="primary"
                        depressed
                        :disabled="
                          !canReviewClockRecord(clockRecord) ||
                          isActionLoading(clockRecord.id, 'ignore') ||
                          isActionLoading(clockRecord.id, 'approve')
                        "
                        :loading="isActionLoading(clockRecord.id, 'approve')"
                        @click="openApproveDialog(clockRecord)"
                      >
                        <v-icon left size="18">mdi-check-circle-outline</v-icon>
                        承認打卡紀錄
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-card-text>
          </v-card>

          <confirm-dialog
            :visible.sync="confirmIgnoreDialog.visible"
            :title="confirmIgnoreDialog.title"
            :message="confirmIgnoreDialog.message"
            :yes-button-text="confirmIgnoreDialog.yesButtonText"
            :no-button-text="confirmIgnoreDialog.noButtonText"
            :yes-callback="confirmIgnoreDialog.yesCallback"
          />

          <v-dialog
            v-model="approveDialog.visible"
            persistent
            max-width="640"
            overlay-opacity="0.8"
          >
            <v-card class="card-shadow border-radius-xl">
              <v-card-title class="text-center pt-6 pb-2">
                承認請假期間打卡紀錄
              </v-card-title>

              <v-card-text class="pt-4">
                <template v-if="approveDialog.clockRecord">
                  <div class="mb-4">
                    <div class="text-body-2 text-secondary mb-1">原始時間</div>
                    <div class="text-body-1 font-weight-medium">
                      <formatted-date
                        :date="
                          approveDialog.clockRecord.extra &&
                          approveDialog.clockRecord.extra.re_clock_in
                        "
                      />
                      ~
                      <formatted-date
                        :date="
                          approveDialog.clockRecord.extra &&
                          approveDialog.clockRecord.extra.re_clock_out
                        "
                      />
                    </div>
                  </div>

                  <div class="mb-4">
                    <div class="text-body-2 text-secondary mb-1">原始時數</div>
                    <div class="text-body-1 font-weight-medium">
                      {{
                        formatHours(
                          getClockRecordRawHours(approveDialog.clockRecord)
                        )
                      }}
                    </div>
                  </div>

                  <v-radio-group
                    v-model="approveDialog.roundingMode"
                    class="mt-2"
                    hide-details
                  >
                    <v-radio
                      v-for="option in roundingModeOptions"
                      :key="option.value"
                      :label="option.label"
                      :value="option.value"
                    />
                  </v-radio-group>

                  <v-alert type="info" outlined dense class="mt-4 mb-0">
                    預計承認時數：
                    {{
                      formatHours(
                        getRoundedHoursPreview(
                          approveDialog.clockRecord,
                          approveDialog.roundingMode
                        )
                      )
                    }}
                  </v-alert>
                </template>
              </v-card-text>

              <v-card-actions class="pb-6 px-6">
                <v-spacer></v-spacer>
                <v-btn
                  class="
                    font-weight-bold
                    text-capitalize
                    btn-ls btn-secondary
                    bg-gradient-light
                    py-3
                    px-6
                  "
                  text
                  :disabled="approveDialog.loading"
                  @click="closeApproveDialog"
                >
                  取消
                </v-btn>
                <v-btn
                  class="
                    font-weight-bold
                    text-capitalize
                    btn-primary
                    bg-gradient-primary
                    py-3
                    px-6
                  "
                  :loading="approveDialog.loading"
                  :disabled="
                    approveDialog.loading ||
                    !getClockRecordRawHours(approveDialog.clockRecord)
                  "
                  @click="submitApproveClockRecord"
                >
                  承認
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <div class="d-flex justify-center py-4">
            <v-pagination
              v-model="leaveReClockPage"
              :length="pageCount"
              @input="fetchLeaveReClock"
              prev-icon="fa fa-angle-left"
              next-icon="fa fa-angle-right"
              color="#cb0c9f"
              circle
            ></v-pagination>
          </div>
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import FormattedDate from "@/components/FormattedDate.vue";
import ConfirmDialog from "@/components/Common/ConfirmDialog.vue";
import {
  REVIEW_STATUS_TEXT,
  REVIEW_STATUS_COLOR,
  LEAVE_TYPE,
} from "@/constants";
import { formatDateTime as formatDateTimeUtil } from "@/utils/time";

const LEAVE_PERIOD_CLOCK_REVIEW_KEY = "leave_period_clock_review";
const ROUNDING_MODE_OPTIONS = [
  { value: "round_down", label: "無條件捨去" },
  { value: "round_up", label: "無條件進位" },
  { value: "round_nearest", label: "四捨五入" },
];

export default {
  name: "LeaveReClockWidget",
  components: {
    FormattedDate,
    ConfirmDialog,
  },
  props: {
    selectedCompany: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      REVIEW_STATUS_TEXT,
      REVIEW_STATUS_COLOR,
      LEAVE_TYPE,
      leaveReClockApplications: [],
      leaveReClockPage: 1,
      leaveReClockItemsPerPage: 10,
      leaveReClockTotalItems: 0,
      leaveReClockTotalPages: 1,
      loadingLeaveReClock: false,
      fetchError: false,
      actionLoading: {
        id: null,
        action: null,
      },
      confirmIgnoreDialog: {
        visible: false,
        title: "確認忽略",
        message: "您確定要忽略這筆請假期間打卡紀錄嗎？",
        yesButtonText: "忽略",
        noButtonText: "取消",
        yesCallback: null,
      },
      approveDialog: {
        visible: false,
        loading: false,
        clockRecord: null,
        roundingMode: "round_nearest",
      },
    };
  },
  computed: {
    pageCount() {
      return this.leaveReClockTotalPages || 1;
    },
    roundingModeOptions() {
      return ROUNDING_MODE_OPTIONS;
    },
  },
  async mounted() {
    await this.fetchLeaveReClock();
  },
  watch: {
    selectedCompany: {
      handler() {
        this.leaveReClockPage = 1;
        this.fetchLeaveReClock();
      },
      deep: true,
    },
  },
  methods: {
    normalizeJsonObject(value) {
      if (!value) {
        return {};
      }

      if (typeof value === "object" && !Array.isArray(value)) {
        return { ...value };
      }

      if (typeof value === "string") {
        try {
          const parsed = JSON.parse(value);
          if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
            return parsed;
          }
        } catch (error) {
          return {};
        }
      }

      return {};
    },
    getClockRecordReviewInfo(clockRecord) {
      const extra = this.normalizeJsonObject(clockRecord?.extra);
      return this.normalizeJsonObject(extra[LEAVE_PERIOD_CLOCK_REVIEW_KEY]);
    },
    isClockRecordHandled(clockRecord) {
      return Boolean(this.getClockRecordReviewInfo(clockRecord)?.handled);
    },
    canReviewClockRecord(clockRecord) {
      const extra = this.normalizeJsonObject(clockRecord?.extra);
      return Boolean(
        extra.re_clock_in &&
          extra.re_clock_out &&
          !this.isClockRecordHandled(clockRecord)
      );
    },
    getClockRecordRawHours(clockRecord) {
      const extra = this.normalizeJsonObject(clockRecord?.extra);
      if (!extra.re_clock_in || !extra.re_clock_out) {
        return null;
      }

      const start = new Date(extra.re_clock_in).getTime();
      const end = new Date(extra.re_clock_out).getTime();

      if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) {
        return null;
      }

      return (end - start) / (60 * 60 * 1000);
    },
    getRoundedHoursPreview(clockRecord, roundingMode) {
      const rawHours = this.getClockRecordRawHours(clockRecord);
      if (!Number.isFinite(rawHours)) {
        return null;
      }

      if (roundingMode === "round_up") {
        return Math.ceil(rawHours);
      }

      if (roundingMode === "round_nearest") {
        return Math.round(rawHours);
      }

      return Math.floor(rawHours);
    },
    formatHours(hours) {
      if (!Number.isFinite(hours)) {
        return "-";
      }

      return `${hours.toFixed(2)} 小時`;
    },
    getRoundingModeLabel(mode) {
      const option = ROUNDING_MODE_OPTIONS.find((item) => item.value === mode);
      return option ? option.label : mode || "-";
    },
    isActionLoading(clockRecordId, action) {
      return (
        this.actionLoading.id === clockRecordId &&
        this.actionLoading.action === action
      );
    },
    openIgnoreDialog(clockRecord) {
      if (!clockRecord || !this.canReviewClockRecord(clockRecord)) {
        return;
      }

      this.confirmIgnoreDialog.yesCallback = async () => {
        await this.ignoreClockRecord(clockRecord);
      };
      this.confirmIgnoreDialog.visible = true;
    },
    async ignoreClockRecord(clockRecord) {
      if (!clockRecord || !clockRecord.id) {
        return;
      }

      this.actionLoading = { id: clockRecord.id, action: "ignore" };
      try {
        await this.$axios.put(
          `/api/applications/leave-re-clock/${clockRecord.id}/ignore`
        );
        await this.fetchLeaveReClock();
      } catch (error) {
        this.$emit("error", {
          title: "忽略打卡紀錄失敗",
          message:
            (error && (error.response?.data?.message || error.message)) ||
            "請稍後再試",
        });
      } finally {
        this.actionLoading = { id: null, action: null };
        this.confirmIgnoreDialog.yesCallback = null;
      }
    },
    openApproveDialog(clockRecord) {
      if (!clockRecord || !this.canReviewClockRecord(clockRecord)) {
        return;
      }

      this.approveDialog.clockRecord = clockRecord;
      this.approveDialog.roundingMode = "round_nearest";
      this.approveDialog.visible = true;
    },
    closeApproveDialog() {
      if (this.approveDialog.loading) {
        return;
      }

      this.approveDialog.visible = false;
      this.approveDialog.clockRecord = null;
      this.approveDialog.roundingMode = "round_nearest";
    },
    async submitApproveClockRecord() {
      const clockRecord = this.approveDialog.clockRecord;
      if (!clockRecord || !clockRecord.id) {
        return;
      }

      this.approveDialog.loading = true;
      this.actionLoading = { id: clockRecord.id, action: "approve" };
      try {
        await this.$axios.put(
          `/api/applications/leave-re-clock/${clockRecord.id}/approve`,
          {
            rounding_mode: this.approveDialog.roundingMode,
          }
        );
        this.approveDialog.visible = false;
        this.approveDialog.clockRecord = null;
        await this.fetchLeaveReClock();
      } catch (error) {
        this.$emit("error", {
          title: "承認打卡紀錄失敗",
          message:
            (error && (error.response?.data?.message || error.message)) ||
            "請稍後再試",
        });
      } finally {
        this.approveDialog.loading = false;
        this.actionLoading = { id: null, action: null };
      }
    },
    async fetchLeaveReClock() {
      this.loadingLeaveReClock = true;
      this.leaveReClockApplications = [];
      this.fetchError = false;
      try {
        const params = new URLSearchParams({
          page: this.leaveReClockPage,
          limit: this.leaveReClockItemsPerPage,
          review_status: 2,
        });

        if (this.selectedCompany && this.selectedCompany.id) {
          params.append("company_id", this.selectedCompany.id);
        }

        const response = await this.$axios.get(
          `/api/applications/leave-re-clock?${params}`
        );
        const payload = response && response.data ? response.data : {};
        const newItems = Array.isArray(payload.data) ? payload.data : [];
        const pagination = payload.pagination || {};

        this.leaveReClockTotalItems =
          Number(pagination.totalItems) || newItems.length || 0;
        this.leaveReClockTotalPages = Number(pagination.totalPages) || 1;
        this.leaveReClockApplications = newItems;
      } catch (error) {
        this.leaveReClockApplications = [];
        this.leaveReClockTotalItems = 0;
        this.fetchError = true;
        this.$emit("error", {
          title: "取得請假期間打卡紀錄失敗",
          message:
            (error && (error.response?.data?.message || error.message)) ||
            "請稍後再試",
        });
      } finally {
        this.loadingLeaveReClock = false;
      }
    },
    getLeaveTypeText(application) {
      const leaveType = application.leave_type;
      return LEAVE_TYPE[leaveType] || leaveType || "請假申請";
    },
    formatDateTime(value) {
      return formatDateTimeUtil(value);
    },
    formatLeaveMinutes(minutes) {
      const mins = Number(minutes);
      if (!Number.isFinite(mins)) {
        return "-";
      }

      const hours = Math.floor(mins / 60);
      const remainder = mins % 60;
      return `${hours}小時${remainder}分鐘`;
    },
  },
};
</script>
